import { AdminLayout } from "@/components/admin/AdminLayout";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card } from "@/components/ui/card";
import { ListLoadingState } from "@/components/loading/ListLoadingState";
import { format } from "date-fns";
export const TransactionList = () => {
  const {
    data: transactions,
    isLoading
  } = useQuery({
    queryKey: ['admin-transactions'],
    queryFn: async () => {
      const {
        data,
        error
      } = await supabase.from('transactions').select(`
          *,
          orders!inner(
            scheduled_date,
            scheduled_time,
            delivery_type
          ),
          chef:profiles!transactions_chef_id_fkey(
            first_name,
            last_name
          ),
          buyer:profiles!transactions_buyer_id_fkey(
            first_name,
            last_name
          ),
          meal:meals(
            name
          )
        `).order('created_at', {
        ascending: false
      });
      if (error) throw error;

      // Transform the data to ensure orders is a single object rather than an array
      return data.map(transaction => ({
        ...transaction,
        orders: transaction.orders[0]
      }));
    }
  });
  return <AdminLayout title="Transactions">
      <div className="space-y-4">
        {isLoading ? <ListLoadingState /> : transactions?.map(transaction => <Card key={transaction.id} className="p-4">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                <div>
                  <p className="text-muted-foreground text-xs">Order ID</p>
                  <p className="font-medium text-xs">{transaction.order_id}</p>
                </div>
                <div>
                  <p className="text-muted-foreground text-xs">Chef</p>
                  <p className="font-medium text-xs">
                    {transaction.chef?.first_name} {transaction.chef?.last_name}
                  </p>
                </div>
                <div>
                  <p className="text-muted-foreground text-xs">Foodie</p>
                  <p className="font-medium text-xs">
                    {transaction.buyer?.first_name} {transaction.buyer?.last_name}
                  </p>
                </div>
                <div>
                  <p className="text-muted-foreground text-xs">Meal</p>
                  <p className="font-medium text-xs">{transaction.meal?.name}</p>
                </div>
                <div>
                  <p className="text-muted-foreground text-xs">Amount</p>
                  <p className="font-medium text-xs">${transaction.amount.toFixed(2)}</p>
                </div>
                <div>
                  <p className="text-muted-foreground text-xs">Purchase Date</p>
                  <p className="font-medium text-xs">
                    {format(new Date(transaction.created_at), 'MMM d, yyyy')}
                  </p>
                </div>
                <div>
                  <p className="text-muted-foreground text-xs">Scheduled Date</p>
                  <p className="font-medium text-xs">
                    {transaction.orders?.scheduled_date ? format(new Date(transaction.orders.scheduled_date), 'MMM d, yyyy') : 'N/A'}
                  </p>
                </div>
                <div>
                  <p className="text-muted-foreground text-xs">Scheduled Time</p>
                  <p className="font-medium text-xs">{transaction.orders?.scheduled_time || 'N/A'}</p>
                </div>
                <div>
                  <p className="text-muted-foreground text-xs">Delivery Type</p>
                  <p className="font-medium capitalize text-xs">{transaction.orders?.delivery_type || 'N/A'}</p>
                </div>
              </div>
            </Card>)}

        {transactions?.length === 0 && <Card className="p-8 text-center">
            <p className="text-muted-foreground">No transactions found</p>
          </Card>}
      </div>
    </AdminLayout>;
};